import { render, staticRenderFns } from "./TransactionWrapper.vue?vue&type=template&id=4add39bb&scoped=true&"
import script from "./TransactionWrapper.vue?vue&type=script&lang=js&"
export * from "./TransactionWrapper.vue?vue&type=script&lang=js&"
import style0 from "./TransactionWrapper.vue?vue&type=style&index=0&id=4add39bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4add39bb",
  null
  
)

export default component.exports